import React, { Component } from "react";
import {
  Paper,
  Subheader,
  Divider,
  FlatButton,
  Card,
  CardHeader,
  CardText,
} from "material-ui";
import Formsy from "formsy-react";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Dropzone from "react-dropzone";
import ScanSnapOCR from "../../data/images/ScanSnapOCR.png";
import ScanSnapIcon from "../../data/images/ScanSnapIcon.png";
import PublishForm from "../PublishForm";

class Upload8879s extends Component {
  constructor(props) {
    super(props);
    const currentYear = new Date().getFullYear();
    const years = Array.from(
      new Array(15),
      (val, index) => currentYear - index,
    );

    this.state = {
      submitEnabled: true,
      message: "Click to upload file, or drag and drop file",
      file: "",
      response: "",
      is8879Uploader: true,
      sourceUpload: {
        isPublishToCCH: false,
        expiryDate: "",
        portalReadOnlyModeFlg: "",
        selectedYear: "",
        userComment: "",
      },
      resMessage: "",
      isLoading: false,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          minHeight: "150px",
          border: "3px dashed #2979ff",
          maxHeight: "290px",
          overflow: "auto",
        },
        activeZone: {
          width: "100%",
          minHeight: "150px",
          border: "3px dashed #2979ff",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
      fileList: [],
    };

    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.checkStatus = this.checkStatus.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  setSourceUpload = (data) => {
    console.log("data", data);
    this.setState({
      sourceUpload: data,
    });
  };

  submitForm(e) {
    e.preventDefault();
    var me = this;
    // alert(JSON.stringify(data, null, 4));
    if (this.state.fileList.length > 0) {
      //For multiple file upload - new code
      //if(this.state.file) { // For use single file upload - old code
      this.setState({ message: "Uploading File", isLoading: true });
      let formData = new FormData();
      formData.append("isPublishToCCH", this.state.sourceUpload.isPublishToCCH);
      formData.append("selectedYear", this.state.sourceUpload.selectedYear);
      formData.append("expiryDate", this.state.sourceUpload.expiryDate);
      formData.append(
        "portalReadOnlyModeFlg",
        this.state.sourceUpload.portalReadOnlyModeFlg,
      );
      formData.append("userComment", this.state.sourceUpload.userComment);
      let url = "/api/documentUpload/upload";
      let options = {
        method: "POST",
        headers: {
          token: this.props.token.jwt,
        },
        body: formData,
      };
      //formData.append('file', this.state.file); // For use single file upload - old code
      this.state.fileList.map((file) => {
        //For multiple file upload - new code
        if (file.type === "application/pdf") {
          formData.append("files", file);
        }
      });

      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          console.log("json--submitForm-------", json);
          me.setState({
            response: [],
            isLoading: false,
            message: json.message,
            resMessage: json.message,
          });
          //this.checkStatus(json.ref)
          /*json.map((jsonData)=>{
				    this.checkStatus(jsonData.ref)
				})*/
        });
    }
  }

  checkStatus(ref) {
    console.log("checkStatus", ref);
    let url = `/api/documentUpload/docUploadReport?ref=${ref}`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        if (json.status === "success") {
          this.setState({
            response: json.response,
            isLoading: false,
            message: "",
            resMessage: json.resMessage,
          });
        } else if (json.status === "failed") {
          this.setState({
            isLoading: false,
            message: `Upload Failed, please contact the administrator with the reference number: ${ref}`,
            resMessage: json.resMessage,
          });
        } else {
          this.setState({ message: json.status });
          setTimeout(() => this.checkStatus(ref), 15000);
        }
      })
      .catch(function (e) {
        console.log("error", e.message);
        //this.setState({isLoading: false, message: e.message})
      });
  }

  notifyFormError(data) {
    alert("Form error:", JSON.stringify(data, null, 4));
  }

  resetForm() {
    this.setState({
      fileList: [],
      file: "",
      response: "",
      isLoading: false,
      message: "Click to upload file, or drag and drop file",
      resMessage: "",
      submitEnabled: true,
    });
  }

  onDrop(e) {
    var me = this;
    if (e.length > 0) {
      let fList = [];
      var toContinue = true;
      e.forEach(function (fileData, index) {
        if (fileData.type === "application/pdf") {
          fileData["reason"] = "";
          fList.push(fileData);
        } else {
          fileData["reason"] = "Expecting PDF";
          fList.push(fileData);
          toContinue = false;
        }
        if (index == e.length - 1) {
          me.setState({ fileList: fList, message: "" });
        }
      });
      me.setState({ submitEnabled: toContinue });
    } else {
      me.setState({
        message: `Incorrect File Type, expecting PDF`,
        submitEnabled: false,
      });
    }

    /*if(e[0].type === 'application/pdf') {
			this.setState({file: e[0]});
		}
		else {
			this.setState({message: `Incorrect File Type, expecting PDF`})
		}*/
  }

  renderContent() {
    let { response, isLoading, resMessage } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
            <h3>{this.state.message}</h3>
          </center>
        </div>
      );
    } else if (!response) {
      return (
        <div style={{ padding: "2rem" }}>
          <Dropzone
            className="rightUploadDiv"
            onDrop={this.onDrop}
            disablePreview={true}
            style={zone}
            activeStyle={activeZone}
          >
            <left style={{ marginLeft: "1rem" }}>
              {this.state.fileList.length > 0 ? (
                this.state.fileList.map((file, index) => {
                  return (
                    <h4 style={{ color: file.reason ? "red" : "#000" }}>
                      {file
                        ? file.reason != ""
                          ? file.name +
                            " is not in PDF format. PDF file is expected."
                          : file.name +
                            " will be submitted for batch processing. A notification will be sent via email once the process is complete."
                        : ""}
                    </h4>
                  );
                })
              ) : (
                <h4>{this.state.message}</h4>
              )}
            </left>
          </Dropzone>
        </div>
      );
    } else {
      return (
        <div style={centerStyle}>
          <h4>Upload Results</h4>
          <p style={{ color: "red", fontWeight: "bold" }}>{resMessage}</p>
          <BootstrapTable data={response}>
            <TableHeaderColumn
              dataField="clientId"
              filter={filter}
              dataSort
              isKey
              width="55"
            >
              Client ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="clientName"
              dataSort
              filter={filter}
              width="270"
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="year"
              dataSort
              filter={filter}
              width="50"
            >
              Year
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="messageCCH"
              dataSort
              filter={filter}
              width="100"
              dataFormat={this.sentFormatter}
            >
              CCH Status
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="pages"
              dataSort
              filter={filter}
              width="35"
            >
              Pgs
            </TableHeaderColumn>
          </BootstrapTable>
          <Card style={{ marginTop: "0.5em", marginBottom: "0.5em" }}>
            <CardHeader
              title="Troubleshooting"
              // titleStyle={{fontWeight: 'bold', fontSize: '150%'}}
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true} style={{ margin: "0.5em" }}>
              <p>
                1. <strong>Only 8879s should be uploaded in this input!</strong>
              </p>
              <p>
                2. If the table says 'There is no data to display' it means the
                PDF that was uploaded did not contain text with ClientIds and
                tax year.
              </p>
              <p>
                To ensure your scanned documents contain text, open the ScanSnap
                Settings by right-clicking{" "}
                <img
                  src={ScanSnapIcon}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  alt="the icon"
                />{" "}
                in the notification tray and selecting '
                <strong>Scan Button Settings...</strong>', Then configure OCR as
                shown in the image below.
              </p>
              <p>
                <center>
                  <img
                    src={ScanSnapOCR}
                    style={{ maxWidth: "75%", maxHeight: "75%" }}
                    alt="File option -> Select OCR -> ConverToSearchablePDF, OCR Options -> All Pages"
                  />
                </center>
              </p>
            </CardText>
          </Card>
        </div>
      );
    }
  }

  sentFormatter(status) {
    let color;
    if (status === "Ignored Duplicate File") {
      color = "orange";
    } else if (status !== "Success") {
      color = "red";
    }

    return <div style={{ color: color }}>{status}</div>;
  }

  render() {
    let { centerStyle, zone, activeZone } = this.state.styles;
    return (
      <div style={{ display: open ? "block" : "none" }}>
        <div style={{ margin: "1em" }}>
          <span className="companyListTitle">Signed 8879 Upload Input</span>
        </div>
        <div className="row" style={{ height: "calc(100vh - 40px)" }}>
          <div className="column d-flex align-items-stretch rightMainDiv">
            {this.renderContent()}
            <PublishForm
              submitEnabled={this.state.submitEnabled && !this.state.isLoading}
              sourceUpload={this.state.sourceUpload}
              setSourceUpload={this.setSourceUpload}
              is8879Uploader={this.state.is8879Uploader}
              submitForm={this.submitForm}
              resetForm={this.resetForm}
            />
            {/* <div style={{float: "right", marginTop: "1rem", position: "absolute", right: "30px"}}>
							<FlatButton disabled={this.state.isLoading} onClick={this.resetForm.bind(this)} className="flatButtonCls" >Reset</FlatButton  >
							<FlatButton disabled={this.state.isLoading || !!this.state.response} type='submit' style={{marginLeft: "2rem"}} className="flatButtonCls" onClick={this.submitForm}>Submit</FlatButton  >

						</div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Upload8879s;



// WEBPACK FOOTER //
// ./app/components/documentUploader/Upload8879s.js